module.exports = {
      id: "c310729defe4e21485faf7128d8ba4caroofShape-mansard.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#c310729defe4e21485faf7128d8ba4caroofShape-mansard.svg",
      toString: function () {
        return this.url;
      }
    }